/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Gym_Equipment_Too_ManyInputs */

const en_us2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A gym can list at most ${i?.max} pieces of equipment.`)
};

const pt_br2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma academia pode ter no máximo ${i?.max} equipamentos.`)
};

const es_419_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un gimnasio puede tener como máximo ${i?.max} equipos.`)
};

const pt_pt2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um ginásio pode ter no máximo ${i?.max} equipamentos.`)
};

const fr_fr2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Une salle peut compter ${i?.max} équipements au maximum.`)
};

const de_de2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein Studio kann höchstens ${i?.max} Geräte haben.`)
};

const it_it2_gym_equipment_too_many = /** @type {(inputs: Gym_Equipment_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una palestra può elencare al massimo ${i?.max} attrezzi.`)
};

/**
* | output |
* | --- |
* | "A gym can list at most {max} pieces of equipment." |
*
* @param {Gym_Equipment_Too_ManyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_equipment_too_many = /** @type {((inputs: Gym_Equipment_Too_ManyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Equipment_Too_ManyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_equipment_too_many(inputs)
	if (locale === "es-419") return es_419_gym_equipment_too_many(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_equipment_too_many(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_equipment_too_many(inputs)
	if (locale === "de-DE") return de_de2_gym_equipment_too_many(inputs)
	if (locale === "it-IT") return it_it2_gym_equipment_too_many(inputs)
	return en_us2_gym_equipment_too_many(inputs)
});
export { gym_equipment_too_many as "gym.equipment_too_many" }